import { Component, OnInit } from '@angular/core';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader-service',
  templateUrl: './loader-service.component.html',
  styleUrls: ['./loader-service.component.css']
})
export class LoaderServiceComponent implements OnInit {

  public status = false;
  subscription: Subscription;
  ngOnInit() {
  }

  constructor(private dashboardFilterService: DashboardFilterService) {
    this.subscription = this.dashboardFilterService.getOpenLoaderStatus().subscribe(status => {
      this.status = status;
    });
  }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/loader-service/loader-service.component.ts